import React from 'react';

import { useMediaQuery } from 'react-responsive';
import { Link, useNavigate } from 'react-router-dom';

import { Program } from 'app/types';

import Loader from 'common/components/Loader/Loader';
import Text from 'common/components/Text/Text';

import {
  scheduleConversion,
  formatNumber,
  detailUrl,
  newDetailUrl,
} from 'common/utils/conversions';
import { navigateTop } from 'common/utils/index';

import styles from 'features/explore/school/SchoolDetail.module.scss';
import textStyles from 'common/styles/text.module.scss';

interface CompProps {
  programId: number;
  similarProgramsRef: React.RefObject<HTMLDivElement>;
  comesFromExplore?: boolean;
}

import { useGetProgramSimilarsQuery } from '../../../../services/exploreApi';
import { useAppDispatch } from 'app/hooks';
import { setFromExplore } from 'features/explore/exploreSlice';
import { ProgramCard } from 'features/explore/common/components/StudySection';

const SimilarPrograms = ({
  programId,
  similarProgramsRef,
  comesFromExplore,
}: CompProps): React.ReactElement => {
  const { data: programs, isLoading } = useGetProgramSimilarsQuery(programId);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const navigateTo = (route: string) => {
    navigateTop();
    dispatch(setFromExplore(false));
    navigate(route);
  };
  const isMobile = useMediaQuery({ maxWidth: 768 });
  if (isLoading) return <Loader />;
  return (
    <div className={styles.sectionContainer} ref={similarProgramsRef} id="similar-programs">
      <div className={styles.sectionTitle}>
        <div className={styles.blueBlock} />
        {comesFromExplore ? (
          <h3 className={styles.titleText}>Similar programs</h3>
        ) : (
          <h2 className={styles.titleText}>Similar programs</h2>
        )}
      </div>
      <div className={styles.programsContainer}>
        {programs?.data.data.map((program: Program) => (
          <div key={program.id}>
            <ProgramCard program={program} logoSchool={program.logo || ''} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimilarPrograms;
